import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import {useSelector} from "react-redux";
import {useEffect, useState} from "react";
import Api, {postApi} from "../Api";
import {styled} from "@mui/material/styles";
import TableRow from "@mui/material/TableRow";
import TableHead from "@mui/material/TableHead";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import moment from "moment";
import {
    Button,
    Dialog, DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    TextField
} from "@mui/material";
import * as React from "react";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import {Delete} from "@mui/icons-material";

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));

const FreqViolations = () => {
    const project = useSelector(state => state.session.project);
    const permissions = useSelector(state => state.permissions.value);
    const [data, setData] = useState([])
    const [showModal, setShowModal] = useState(false)
    const [steamid, setSteamId] = useState()
    const [nickname, setNickname] = useState()
    const getData = async () => {
        setData(await Api('admin/violators/list'))
    }
    useEffect(() => {
        getData()
    }, []);
    const addInList = async () => {
        postApi(`admin/violators/add/${project}`, {nickname: nickname, steam: steamid}).then(setShowModal(false)).then(getData)
    }
    const deleteRow = async (id) => {
        postApi(`admin/violators/delete/${project}/${id}`, ).then(setShowModal(false)).then(getData)
    }
    return <Paper sx={{ width: '100%', overflow: 'hidden', p:1 }}>
        <Typography variant={'h5'} sx={{p:2}}>Список частых нарушителей: {project.toUpperCase()}</Typography>
        <TableContainer sx={{ maxHeight: 'calc(90vh - 80px)'}}>
            <Table stickyHeader aria-label="sticky table" size={"small"}>
                <TableHead>
                    <TableRow>
                        <TableCell>Дата и время внесения</TableCell>
                        <TableCell>Никнейм</TableCell>
                        <TableCell>STEAM_ID</TableCell>
                        <TableCell>Дата вынесения</TableCell>
                        {permissions.includes('manage_violators') && <TableCell/>}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {!data.length && <TableCell colSpan={5}>Список пуст</TableCell>}
                    {data.length > 0 && data.map((i,e)=><StyledTableRow key={`fv_row_${e}`}>
                        <TableCell>{moment(i.inserted_date).format('DD.MM.YYYY HH:mm:ss')}</TableCell>
                        <TableCell>{i.nickname}</TableCell>
                        <TableCell>{i.steam_id}</TableCell>
                        <TableCell>{moment(i.cooldown_date).format('DD.MM.YYYY HH:mm:ss')}</TableCell>
                        {permissions.includes('manage_violators') && <TableCell>
                            <IconButton onClick={()=>{deleteRow(i.id)}}><Delete/></IconButton>
                        </TableCell>}
                    </StyledTableRow>)}
                </TableBody>
            </Table>
        </TableContainer>
        {permissions.includes('manage_violators') &&
            <Box sx={{ flexGrow: 0, marginTop: 1 }}>
                <Button variant={'contained'} color={'warning'} onClick={() => { setShowModal(true) }}>ДОБАВИТЬ</Button>
            </Box>
        }
        {permissions.includes('manage_violators') && (
            <Dialog
                open={showModal}
                onClose={() => { setShowModal(false) }}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    {"Добавление игрока в Список частых нарушителей"}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText component={'span'} id="alert-dialog-description">
                        <TextField
                            fullWidth
                            value={steamid}
                            placeholder="STEAMID)"
                            onChange={(e) => { setSteamId(e.target.value) }}
                            sx={{ mb: 2 }}
                        />
                        <TextField
                            fullWidth
                            value={nickname}
                            placeholder="Никнейм"
                            onChange={(e) => { setNickname(e.target.value) }}
                            sx={{ mb: 2 }}
                        />
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => { setShowModal(false) }} color={'info'} variant={'contained'} autoFocus>
                        Отмена
                    </Button>
                    <Button onClick={addInList} color={'error'} variant={'contained'}>
                        Внести
                    </Button>
                </DialogActions>
            </Dialog>
        )}
    </Paper>
}

export default FreqViolations;